import styled from 'styled-components'

export const TableContainer = styled.div<{ background?: string }>`
  align-items: center;
  padding-bottom: 40px;
  background-color: ${(props) => props.background || ''};
  overflow-x: auto;
  max-width: 100%;
`
export const PaginationDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 2rem 0;
`
export const Table = styled.table`
  width: 100%;
  text-align: left;
  border-collapse: collapse;
  table-layout: auto;
`
export const TableRow = styled.tr`
  border-bottom: 1px solid #ddd;
  position: relative;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(198, 1, 107, 0.02);
  }

  &.selected {
    background-color: rgba(198, 1, 107, 0.05);
    border-left: 4px solid #c6016b;
  }

  &.isEditing {
    background-color: rgba(45, 116, 156, 0.05);
  }
`
export const TableHeaders = styled.thead`
  margin-bottom: 30px;
  border-bottom: 1px solid #1f2124;
  padding: 0.3em;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  cursor: pointer;
`
export const TableHeader = styled.th``

export const TableCell = styled.td`
  text-align: left;
  width: auto;
  min-width: fit-content;
  overflow: visible;
  white-space: normal;
  position: relative;
  word-wrap: break-word;
  word-break: break-word;
  padding: 8px;
`

export const NumberCell = styled.td`
  width: 60px;
  max-width: 60px;
  min-width: 60px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  padding: 15px;
`

export const CheckboxCell = styled.td`
  width: 40px;
  max-width: 40px;
  min-width: 40px;
  text-align: center;
`

export const ActionsCell = styled.td`
  font-weight: bold;
  align-items: center;
  justify-content: flex-end;
`
export const UpdateLink = styled.a`
  align-items: center;
  justify-content: center;
  color: #2d749c;
  font-weight: bold;
  cursor: pointer;
`

export const TableBody = styled.tbody`
  border-top: 1px solid;
  padding-top: 30px;
  justify-content: space-between;
  min-height: 400px;
`
export const TextView = styled.span`
  //  font family public sans serif
  font-family: 'Public Sans';
  color: #c6016b;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  cursor: pointer;
`
export const TextUpdate = styled.span`
    //  font family public sans serif
    font-family: 'Public Sans';
    justify-Content: flex-end;
    display: flex;    align-items:center;font-weight: 700;
    font-siz e : 16px;
    line-h ei ght: 24px;
    margin: 0;
    cursor: pointer;
    color:#2D749C;

`

export const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
`
